import { memo, useCallback, useState } from 'react';
import { Dialog } from '../Dialog/Dialog';
import { translates } from '../../constants/translates';
import {useChat} from "../../context/Context";

export const LeaveDialogs = memo(({ showChatHandler, hideChatHandler }) => {
    const [isShowConfirm, setShowConfirm] = useState(false);
    const {defaultLang} = useChat();

    const toggleConfirm = useCallback(() => {
        setShowConfirm((prev) => !prev);
    }, []);

    return !isShowConfirm ? (
        <Dialog
            title={translates[defaultLang].cancel_dialog}
            onCancel={showChatHandler}
            onSend={toggleConfirm}
            applyText={translates[defaultLang].close}
            cancelText={translates[defaultLang].cancel}
        />
    ) : (
        <Dialog
            title={translates[defaultLang].complete_askings}
            onCancel={hideChatHandler}
            onSend={hideChatHandler}
            applyText={translates[defaultLang].apply_btn}
            cancelText={translates[defaultLang].cancel_btn}
        />
    );
});
